import { callActor } from '../../../features/call';
import { CallState } from '../../../features/call/call.types';
import { resetFileTransferState } from '../../../features/fileTransfer/fileTransfer.slice';
import { store } from '../../../stores/redux';
import { type Subscription } from 'xstate';
import { closeModal } from '../../../features/modals/modals.slice';
import { ModalId } from '../../../features/modals/modals.type';
import { dismissAllNotifications } from './fileTransferNotificationUtils';

const subscribeToCallState = (): Subscription =>
  callActor.subscribe((state) => {
    const currentState = (
      typeof state.value === 'string'
        ? state.value
        : Object.keys(state.value)[0]
    ) as CallState;

    if (
      currentState === CallState.Leaving ||
      currentState === CallState.Restarting ||
      currentState === CallState.Idle
    ) {
      store.dispatch(resetFileTransferState());
      store.dispatch(closeModal(ModalId.FileTransfer));
      void dismissAllNotifications();
    }
  });

export { subscribeToCallState };
